import { Box, CircularProgress, Divider, Menu, MenuItem } from '@material-ui/core';
import React from 'react';

import { Font } from '@/components/shared/components/Font';
import { useMoreActionsMenu } from '@/components/shared/components/MoreActionsMenu/hooks/useMoreActionsMenu';
import { ActionsOption } from '@/components/shared/components/MoreActionsMenu/types/ActionsOption';
import { Text } from '@/components/shared/components/Text';

interface MoreActionsMenuInterface extends Omit<React.ComponentProps<typeof Menu>, 'open'> {
  children: React.ReactElement;
  actionsOptionsArray: ActionsOption[];
  boxProps?: React.ComponentProps<typeof Box>;
}

export const MoreActionsMenu = ({ children, actionsOptionsArray, ...props }: MoreActionsMenuInterface) => {
  const { anchorEl, closeMenu, openMenu } = useMoreActionsMenu();

  const handleMenuItemClick = (e, menuItemClick) => {
    e.stopPropagation();
    closeMenu(e);
    menuItemClick();
  };

  return (
    <>
      {React.cloneElement(children, { onClick: openMenu })}
      <Menu
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        anchorEl={anchorEl}
        onClose={closeMenu}
        {...props}
        open={Boolean(anchorEl)}
      >
        {actionsOptionsArray.length > 0 ? (
          actionsOptionsArray.map((action, i) => {
            const color = action.color ?? 'textSecondary';
            return (
              <div key={i}>
                <MenuItem onClick={(e) => handleMenuItemClick(e, action.onClick)} disabled={action.disabled ?? false}>
                  <Font variant={'subtitle2'} color={color} style={{ width: '100%' }}>
                    <Box width={'100%'} display={'inline-flex'} alignItems={'center'} justifyContent={'space-between'}>
                      {action.display}
                      {action.iconName && (
                        <i className={'material-icons-outlined'} style={{ fontSize: 18, paddingLeft: 16 }}>
                          {action.iconName}
                        </i>
                      )}
                      {action.currentSelection && (
                        <i className={'material-icons-outlined'} style={{ fontSize: 18, paddingLeft: 16 }}>
                          done
                        </i>
                      )}
                    </Box>
                  </Font>
                </MenuItem>
                {action.divider && <Divider light />}
              </div>
            );
          })
        ) : (
          <MenuItem disabled>
            <Font variant={'subtitle2'} color={'textSecondary'} style={{ width: '100%' }}>
              <Box width={'100%'} display={'inline-flex'} alignItems={'center'} justifyContent={'space-between'}>
                <Text tId={'NO_ACTIONS_AVAILABLE'} />
              </Box>
            </Font>
          </MenuItem>
        )}
      </Menu>
      {actionsOptionsArray.find((action) => action.loading) && (
        <Box
          position={'absolute'}
          top={0}
          right={'-25px'}
          width={'100%'}
          height={'100%'}
          display={'inline-flex'}
          alignItems={'center'}
          justifyContent={'flex-end'}
        >
          <CircularProgress color={'inherit'} size={20} />
        </Box>
      )}
    </>
  );
};
